/**
 * 开发者评论store
 */
import request from "@/api/store/management";

const defaultQueryParams = {
    pageNum: 1,
    pageSize: 50,
    appName: "",
    appId: null,
    keyWord: "",
    replyStatus: null,
    startDate: "",
    endDate: ""
}

const state = {
    // 获得列表时的提交参数
    queryForm: {...defaultQueryParams},

    //是否加载中
    isLoading: false,

    // 评论列表
    response: {
        total: 0,
        rows: []
    },

    //常量
    optionReplyStatus: [
        { label: "审核中", value: 0 },
        { label: "审核通过", value: 1 },
        { label: "审核不通过", value: 2 },
    ]
}

const mutations = {
    getCommentList(state) {
        state.isLoading=true
        request.getComments(state.queryForm).then(results=>{
            if(results.code == 200){
                state.response = results
            }else{
                return Promise.reject(results)
            }
        }).catch(err=>{
            return Promise.reject(err)
        }).finally(()=>{
            state.isLoading = false
        })
    },

    replyComment(state, payload){
        console.log(payload)
        return request.replyComment(payload)
    }
}

const actions = {
    query({commit, state}, payload) {
        state.queryForm = payload
        commit('getCommentList');
    },

    resetQueryForm({state}){
        state.queryForm = {...defaultQueryParams}
    },

    reply({commit}, payload){
        commit("replyComment", payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
